import React from 'react';
import { Wrapper, Content, Container } from './elements';
import Sidebar from './components/SideBar';
import ScrollTop from './components/ScrollTop';
import { PageLoader } from 'features/shared/PageLoader';
import Header from './components/Header';
import AdvertisementPopup from 'features/shared/AdvertisementPopup';
import { useBannersContext } from 'features/shared/Banners/BannersContext';
import { useLocation } from 'react-router-dom';
import Feedback from 'features/shared/Feedback';

interface MainProps {
  ready: boolean;
}

const Main = (props: React.PropsWithChildren<MainProps>) => {
  const { isFetching } = useBannersContext();
  const location = useLocation();
  const ready = location.pathname.match('schools') ? !isFetching && props.ready : props.ready;

  return (
    <Wrapper>
      <Container>
        <Sidebar />
        <div style={{ width: 1020 }}>
          <Header />
          <Content>{ready ? props.children : <PageLoader />}</Content>
        </div>
      </Container>
      <AdvertisementPopup ready={ready} />
      <Feedback />
      <ScrollTop scrollStepInPx="150" delayInMs="25" />
    </Wrapper>
  );
};

export default Main;
